import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import './SearchBox.css';
import { IoIosSearch } from 'react-icons/io';
import { InputGroup } from 'react-bootstrap';

function SearchBox({ getFilterUrl, navigate }) {
	const [query, setQuery] = useState();

	const [isActiveSearch, setActive] = useState(true);

	const submitHandler = (e) => {
		e.preventDefault();
		const filterUrl = getFilterUrl({ query });
		setActive(!isActiveSearch);
		navigate(filterUrl);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			submitHandler(e);
		}
	};

	return (
		<InputGroup className='search-box'>
			<InputGroup.Text onClick={submitHandler}>
				<IoIosSearch />
			</InputGroup.Text>
			<Form.Control
				name='query'
				placeholder='Buscar'
				aria-label='buscar cuenta'
				type='text'
				value={query}
				onChange={(e) => setQuery(e.target.value.replace(/[\\^$*+?()|[\]{}]/g, ''))}
				onKeyDown={handleKeyDown}
			/>
		</InputGroup>
	);
}

export default SearchBox;
